<template>
  <el-select v-model="form.country_id" name="country" :disabled="disabled" :loading="loading" filterable placeholder="Select your country" @change="$emit('input', $event)">
    <el-option v-for="(name, id) in countries" :key="id" :label="name" :value="id"></el-option>
  </el-select>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      countries: [],
      form: {
        country_id: this.value,
      },
    }
  },

  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    value: {
      default: null,
      type: String,
    },
  },

  async mounted() {
    this.loading = true

    try {
      var { data } = await this.$http.get('/countries')
    } catch(err) {
      this.$message.error(err.response.data.message)
      return false
    } finally {
      this.loading = false
    }

    this.countries = data.countries
  },
}
</script>
